import { CARD_DISPLAY, COMPARE_DATA } from '../data/homepageData';

// Which photo represents a product in a card, thumbnail or summary row.
//
// A product's gallery leads with whatever shot sells the page it sits on -
// for the AW01 that is a lifestyle hero with a garden behind it. That is the
// wrong image at thumbnail size, where the product has to be recognisable in
// a 150 px box: there the plain shot of the awning on a clean background
// reads instantly. So a product can pin a card image, and everything that
// draws a card reads it from here rather than reaching for `images[0]`
// itself - which is how the homepage came to show one photo and /products
// another for the same awning.
//
// Resolution order:
//   1. product.card_image - the field on the record. Preferred, because the
//      server can read it too and the marketing emails need the same picture
//      the site shows; the constants below are client-only.
//   2. CARD_DISPLAY[slug].cardImages - a pinned set (the homepage card's
//      four-image strip); its first entry is the card image.
//   3. COMPARE_DATA[slug].cardImage - a single pinned card image.
//   4. The product's own first gallery image.
// The product page hero, og:image and product schema deliberately keep
// using the gallery order.

function slugOf(product) {
  return (product && (product.slug || product._id)) || '';
}

export function cardImage(product) {
  if (!product) return null;
  if (product.card_image) return product.card_image;
  const slug = slugOf(product);
  const pinnedSet = CARD_DISPLAY[slug]?.cardImages;
  if (pinnedSet && pinnedSet[0]) return pinnedSet[0];
  const pinned = COMPARE_DATA[slug]?.cardImage;
  if (pinned) return pinned;
  const gallery = (product.images || []).filter(Boolean);
  return gallery[0] || null;
}

// The images a card's own gallery strip shows, card image first. Products
// without a pinned set fall back to their gallery in order.
export function cardImages(product, max = 4) {
  if (!product) return [];
  const slug = slugOf(product);
  const pinnedSet = (CARD_DISPLAY[slug]?.cardImages || []).filter(Boolean);
  if (pinnedSet.length) return pinnedSet.slice(0, max);
  const gallery = (product.images || []).filter(Boolean);
  const lead = cardImage(product);
  const ordered = lead ? [lead, ...gallery.filter((src) => src !== lead)] : gallery;
  return ordered.slice(0, max);
}
